/**
 * Admin / Library / Analytics API wrappers. Uses withCredentials so the
 * Emergent session cookie travels with each request.
 */
import axios from "axios";

const client = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    withCredentials: true,
});

export const adminApi = {
    listVideos: () => client.get("/admin/videos").then((r) => r.data),
    listStudies: () => client.get("/admin/studies").then((r) => r.data),
    uploadVideo: (file, title, description, onProgress) => {
        const form = new FormData();
        form.append("file", file);
        form.append("title", title);
        form.append("description", description || "");
        return client
            .post("/admin/videos", form, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 0,
                onUploadProgress: (e) => {
                    if (onProgress && e.total) onProgress(e.loaded / e.total);
                },
            })
            .then((r) => r.data);
    },
    deleteVideo: (id) => client.delete(`/admin/videos/${id}`).then((r) => r.data),
    uploadStudy: (file, title, videoId) => {
        const form = new FormData();
        form.append("file", file);
        form.append("title", title);
        if (videoId) form.append("video_id", videoId);
        return client
            .post("/admin/studies", form, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 0,
            })
            .then((r) => r.data);
    },
    deleteStudy: (id) => client.delete(`/admin/studies/${id}`).then((r) => r.data),
    attachStudy: (studyId, videoId) =>
        client
            .patch(`/admin/studies/${studyId}/attach`, { video_id: videoId || null })
            .then((r) => r.data),
};

export const libraryApi = {
    listVideos: () => client.get("/library/videos").then((r) => r.data),
    getVideo: (id) => client.get(`/library/videos/${id}`).then((r) => r.data),
    streamUrl: (id) => `${process.env.REACT_APP_BACKEND_URL}/api/files/videos/${id}`,
    studyUrl: (id) => `${process.env.REACT_APP_BACKEND_URL}/api/files/studies/${id}`,
};

export const analyticsApi = {
    summary: () => client.get("/analytics/summary").then((r) => r.data),
    visit: (payload = {}) => client.post("/analytics/visit", payload).then((r) => r.data),
};
